/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import NumberFormat from 'react-number-format';
import { useTranslate } from 'hooks/useTranslate';

import {
  currencyFormat,
  currencyFormatDecimals,
  numberFormat,
  numberFormatDecimals,
} from 'constants/formats';

export type CellFormat =
  | 'numberFormat'
  | 'numberFormatDecimals'
  | 'currencyFormat'
  | 'currencyFormatDecimals';

type WidgetLegalTableExtendedCellProps = {
  value: string | number;
  format?: CellFormat;
  cellClass?: string;
  textClass?: string;
};

export const cellFormats: Record<string, CellFormat> = {
  NUMBER_FORMAT: 'numberFormat',
  NUMBER_FORMAT_DECIMALS: 'numberFormatDecimals',
  CURRENCY_FORMAT: 'currencyFormat',
  CURRENCY_FORMAT_DECIMALS: 'currencyFormatDecimals',
};

const formats = {
  [cellFormats.NUMBER_FORMAT]: numberFormat,
  [cellFormats.NUMBER_FORMAT_DECIMALS]: numberFormatDecimals,
  [cellFormats.CURRENCY_FORMAT]: currencyFormat,
  [cellFormats.CURRENCY_FORMAT_DECIMALS]: currencyFormatDecimals,
};

const WidgetLegalTableExtendedCell: FC<WidgetLegalTableExtendedCellProps> = ({
  value,
  format,
  cellClass,
  textClass,
}) => {
  const { t } = useTranslate();

  const isNumber = typeof value === 'number';
  const isString = typeof value === 'string';
  const isTranslated = true;

  const currentFormat = formats?.[format || cellFormats.NUMBER_FORMAT];

  const cellClassName = `nk-tb-col ${cellClass || ''} ${
    isNumber ? 'text-right' : ''
  }`;
  const textClassName = `tb-sub ${textClass || ''}`;

  return (
    <td className={cellClassName}>
      <span className={textClassName}>
        {isNumber && (
          <NumberFormat value={value} displayType="text" {...currentFormat} />
        )}

        {isString && (
          <span className="text-left">{isTranslated ? t(value) : value}</span>
        )}
      </span>
    </td>
  );
};

export default WidgetLegalTableExtendedCell;
